import type { FC, ReactElement } from 'react';

import { useDispatch } from 'react-redux';

import useCloseModalOnBack from 'hooks/useCloseModalOnBack';
import useDisableScroll from 'hooks/useDisableScroll';
import useKeyPress from 'hooks/useKeyPress';

import { toggleModal } from 'data/actions/modals';

import { ModalContainer } from './styles';

const ModalLayout: FC<{
  children: ReactElement;
  customHandleKeyPress?: unknown;
  fullSizeModal?: boolean;
}> = ({ children, customHandleKeyPress, fullSizeModal = false }) => {
  const dispatch = useDispatch();

  const handleKeyPress = () => {
    if (typeof customHandleKeyPress === 'function') customHandleKeyPress();
    else dispatch(toggleModal({ visible: false }));
  };

  useDisableScroll();
  useKeyPress({ targetKey: 'Escape', onKeyPressDown: handleKeyPress });
  useCloseModalOnBack();

  return <ModalContainer fullSizeModal={fullSizeModal}>{children}</ModalContainer>;
};

export default ModalLayout;
